import gql from 'graphql-tag'

export const MENU_ITEMS_QUERY = gql`
  query MenuItems {
    menuItems {
      id
      name
      path
      icon
      sortOrder
      adminOnly
      category
      parentId
      visibleInSidebar
      routeName
      kind
      children {
        id
      }
    }
  }
`

export const MENU_PERMISSIONS_QUERY = gql`
  query MenuPermissions {
    menuPermissions {
      id
      menuId
      roleId
      canView
      canEdit
      canDelete
      MenuItem {
        id
        name
        path
      }
      Role {
        id
        name
      }
    }
  }
`

const NAVIGATION_ITEM_FIELDS = `
  id
  name
  path
  icon
  adminOnly
  sortOrder
  category
  parentId
  visibleInSidebar
  routeName
  kind
  permission {
    canView
    canEdit
    canDelete
    inherited
  }
`

export const NAVIGATION_TREE_QUERY = gql`
  query NavigationTree {
    navigationTree {
      id
      name
      items {
        ${NAVIGATION_ITEM_FIELDS}
        children {
          ${NAVIGATION_ITEM_FIELDS}
          children {
            ${NAVIGATION_ITEM_FIELDS}
          }
        }
      }
    }
  }
`

export const ALL_NAVIGATION_TREE_QUERY = gql`
  query AllNavigationTree {
    allNavigationTree {
      id
      name
      items {
        ${NAVIGATION_ITEM_FIELDS}
        children {
          ${NAVIGATION_ITEM_FIELDS}
          children {
            ${NAVIGATION_ITEM_FIELDS}
          }
        }
      }
    }
  }
`

export const UPDATE_MENU_PERMISSION_MUTATION = gql`
  mutation UpdateMenuPermission($input: UpdateMenuPermissionInput!) {
    updateMenuPermission(input: $input) {
      id
      menuId
      roleId
      canView
      canEdit
      canDelete
      MenuItem { id name path }
      Role { id name }
    }
  }
`
